export const TYPES = {
  TEXT: 'Text',
  DROP_DOWN: 'Drop Down',
  COMBO: 'Combo'
};
export const CUSTOM_FIELD_VISIBILITY_VALUE = 'SHOW';
export const CUSTOM_FIELD_HIDDEN_VALUE = 'SELECT';
